import api from './api';

/**
 * Client-side service for the biller → front-desk task queue.
 * See server/src/routes/claimActionRequests.js for the route shape.
 */

export function listClaimActionRequests(params = {}) {
  return api.get('/claim-action-requests', { params });
}

export function getOpenClaimActionRequestCount() {
  return api.get('/claim-action-requests/count');
}

export function createClaimActionRequest(data) {
  return api.post('/claim-action-requests', data);
}

export function startClaimActionRequest(id) {
  return api.post(`/claim-action-requests/${id}/start`);
}

export function resolveClaimActionRequest(id, resolution_notes) {
  return api.post(`/claim-action-requests/${id}/resolve`, { resolution_notes });
}

export function cancelClaimActionRequest(id) {
  return api.post(`/claim-action-requests/${id}/cancel`);
}
